import React, { Fragment, useLayoutEffect, useRef, useState } from "react"
import PrismaZoom from "react-prismazoom"
import { FaCircleChevronRight } from "react-icons/fa6"
import { FaCircleChevronLeft } from "react-icons/fa6"
import { FaTimes } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Modal } from "components"
import classes from "./LightBox.module.scss"

const LightBox = (props) => {
  const {
    open,
    close,
    images,
    index: currentPhotoIndex = 0,
    field = ""
  } = props

  const i18n = useTranslation()[1]

  const [photoIndex, setPhotoIndex] = useState(currentPhotoIndex)

  const ref = useRef(null)

  const handleClickNext = () => {
    ref.current.reset()

    setPhotoIndex(
      (photoIndex + 1) % images.length
    )
  }

  const handleClickPrevious = () => {
    ref.current.reset()

    setPhotoIndex(
      (photoIndex + images.length - 1) % images.length
    )
  }

  useLayoutEffect(() => {
    setPhotoIndex(currentPhotoIndex)
  }, [currentPhotoIndex])

  if (!images) return null

  const image =
    field ? images[photoIndex][field] : images[photoIndex]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={open}
      onHide={close}
      dialogClassName={classes["dialog"]}
      contentClassName={classes["content"]}
      topBarComponent={() =>
        <Fragment>
          <div className={clsx(classes["topbar"], isLtr && classes["topbar-ltr"])}>
            <button className={classes["close"]} onClick={close}>
              <FaTimes size={30} />
            </button>
          </div>

          <button
            className={clsx(classes["right"], isLtr && classes["right-ltr"])}
            onClick={handleClickNext}
          >
            <FaCircleChevronRight />
          </button>

          <button
            className={clsx(classes["left"], isLtr && classes["left-ltr"])}
            onClick={handleClickPrevious}
          >
            <FaCircleChevronLeft />
          </button>
        </Fragment>
      }
    >
      <PrismaZoom
        animDuration={0}
        ref={ref}
      >
        <img width="100%" src={image} alt="" />
      </PrismaZoom>
    </Modal>
  )
}

export default LightBox